<template>
<v-container>
    <div v-if="pto_access == 'Y'">
        <v-row class="pb-0">
            <v-col>
                <h1>Paid Time-Off</h1>
                <p>Please note that this information may not accurately reflect the time off you have earned or have available to use. This is due to delayed input of days, time taken off for disability, worker’s compensation, FMLA, or unpaid leave in the current academic year. <strong>If you have any questions or edits, please contact <a class="bold-link" href="https://www.adelphi.edu/hr/contact-us/" target="_blank">Human Resources.</a></strong></p>
                <p>For all FMLA, Short Term Disability, Long Term Disability or NYPFL inquiries please contact <a class="bold-link" href="mailto:mybenefits@adelphi.edu">mybenefits@adelphi.edu</a></p>
                <p>For more information, please visit the <a class="bold-link" href="https://www.adelphi.edu/it-services/my-profile-paid-time-off-pto/" target="_blank">Paid Time Off (PTO) service catalog listing</a>.</p>
            </v-col>
        </v-row>
        <v-row v-if="this.$router.currentRoute.path.includes('manager')" justify="center" class=" pr-2">
          <v-expansion-panels accordion focusable flat>
          <v-expansion-panel>
            <v-expansion-panel-header class="video_header" @click="pauseYouTube('mgr')" >Click here to view short video tutorial for manager on how to use the new digital PTO portal</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="iframe-container">
                  <iframe id="mgr" width="560" height="315" src="https://www.youtube.com/embed/Ptp3j5gQ7I8?enablejsapi=1" title="PTO Requests: Manager's Guide" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; " allowfullscreen></iframe>
                </div>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>        
        </v-row>        
        <v-row v-else-if="!this.$router.currentRoute.path.includes('balance')" justify="center" class="pr-2">
          <v-expansion-panels accordion focusable flat>
          <v-expansion-panel>
            <v-expansion-panel-header class="video_header" @click="pauseYouTube('emp')" >Click here to view short video tutorial for employee on how to use the new digital PTO portal</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="iframe-container">
                  <iframe id="emp" width="560" height="315" src="https://www.youtube.com/embed/3K-MSRVszvk?enablejsapi=1" title="PTO Requests: Employee Guide" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; " allowfullscreen></iframe>
                </div>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>        
      </v-row>

    <v-alert
        outlined
        color="purple"
        v-if="canImpersonate"
        class="admin"
      >
        Admin User: <a href="./remote-apis/impersonate.php"><span v-if="impersonating">Stop impersonating</span><span v-else>impersonate</span></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="impersonating" class="imp">You are impersonating {{ impersonate_display }} </span>
    </v-alert>

    <v-alert v-if="site_status!='saas_locked'"
        outlined
        class="row pr-2 alert_red"
      >
      If you notice any discrepancies, please contact the office of Human Resources at <a class="bold-link" href="mailto:pto@adelphi.edu">pto@adelphi.edu</a> with any pertinent information so that we may investigate further.
    </v-alert>
    <v-alert v-else
        border="top"
        colored-border
        type="info"
        elevation="2"
      >
        During our PTO reconciliation process you will not be able to request future leave until our anticipated completion date of September 16, 2022. <br /><br />
        We apologize for the inconvenience but please note this does not mean you can't take leave during this time. We ask that you communicate with your manager or whomever traditionally approves your leave to seek approval. <br /><br />
        Thank you for your patience. <br />
      </v-alert>

  <div v-if="site_status!='saas_locked'">
    <v-layout row>
      <v-tabs :key="$route.fullPath" show-arrows>
        <v-tabs-slider color="#ffb500"></v-tabs-slider>
        <v-tab v-if="ptoInfo['showReqBalTab']" to="/pto/request"> Request </v-tab>
        <v-tab v-if="ptoInfo['showBalPrevTab']" to="/pto/balancePrev"> {{this.prev_year_str}} Balance </v-tab>  
        <v-tab v-if="ptoInfo['showReqBalTab'] && ptoInfo['showBalanceBadge']" to="/pto/balance"> <v-badge color="pink" dot right
              >{{this.cur_year_str}} Balance</v-badge> </v-tab>
        <v-tab v-else-if="ptoInfo['showReqBalTab']" to="/pto/balance"> {{this.cur_year_str}} Balance </v-tab>
        <v-tab v-if="ptoInfo['showBalNextTab']" to="/pto/balanceNext"> {{this.next_year_str}} Balance </v-tab>  
        <v-tab v-if="ptoInfo['showManagerTab'] && ptoInfo['showManagerBadge']" to="/pto/manager"> 
              <v-badge color="pink" dot right>Managers</v-badge> </v-tab>        
        <v-tab v-else-if="ptoInfo['showManagerTab']" to="/pto/manager"> Managers </v-tab>
        <v-tab v-if="ptoInfo['showCompWeekForm']" to="/pto/compressed"> Compressed Workweek </v-tab>
      </v-tabs>
    </v-layout>

    <v-container>
      <router-view v-if="this.afterCreated" :ptoInfo="this.ptoInfo" :key="$route.fullPath"></router-view>
    </v-container>
  </div>

    <div class="text-center">
      <v-dialog v-model="this.timeout_dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">
            Alert!
          </v-card-title>
          <v-card-text>Your session is about to expire!<br>Do you want to stay signed in?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer> 
            <v-btn color="red darken-1" class="mr-20" text @click="closeTimeoutDialog('signOut')">
              No, Sign me out
            </v-btn>             
            <v-btn color="blue darken-1" text @click="closeTimeoutDialog('keepAlive')">
              Yes, Keep me signed in
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div> 
    </div>

    <div v-else>
      <v-alert
        outlined
        color="purple"
        v-if="canImpersonate"
        class="admin"
      >
        Admin User: <a href="./remote-apis/impersonate.php"><span v-if="impersonating">Stop impersonating</span><span v-else>impersonate</span></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="impersonating" class="imp">You are impersonating {{ impersonate_display }} </span>
    </v-alert> 
      <h3 v-if="afterCreated == true">This section for Full Time Non-Union and Local 153 Employees</h3> 
    </div>
</v-container>
</template>

<script>
import axios from "axios";
import pto_func from "@/pto_functions";

export default {

  data: () => ({
    pto_access: "N",
    canImpersonate: false,
    impersonating: "",
    imp: "",
    site_status: pto_func.get_site_status(),
    cur_year_str: pto_func.get_fiscal_year("cur_str_short"),
    next_year_str: pto_func.get_fiscal_year("next_str_short"),
    prev_year_str: pto_func.get_fiscal_year("prev_str_short"),

    afterCreated: false,
    timeout_dialog: false,
    timeout_redirect: null,

    ptoInfo: {
        showBalanceBadge: false,         
        showManagerTab: false,
        showManagerBadge: false,
        showDelegateForm: false,
        showReqBalTab: true,  
        showBalNextTab: false,
        showBalPrevTab: false,
        p_cfm_this_month: "",
        p_cfm_prev: false,
        ptopc_pending_confirmed: "",
        ptopc_manager: "",
        ptopc_pending_months: "",
        ptopc_pending_mgr_approval: "N",
        delegate_access: "",
        delegate_approvals: "",
        who_delegated: "",
        showCompWeekInfo: false,
        showCompWeekForm: false,
        showCompWeekBadge: false,
        cw_opt_in: 0,
        cw_day: "",
        isFaculty: false,
    },

  }),
  
  created() {
      axios.get("./remote-apis/pto_api.php?cmd=pto_imp").then((response) => {
        this.imp = response.data;
        this.canImpersonate = this.imp.canImpersonate;
        this.impersonating = this.imp.impersonating;
        this.impersonate_display = pto_func.maskEmpName(this.imp.impersonating);
      });

      axios.get("./remote-apis/pto_api.php?cmd=pto_pc").then((response) => {
        this.pc = response.data;
        if (this.pc.response == 0) {
            this.ptoInfo['ptopc_pending_confirmed']  = this.pc.pending_confirmed;
            this.ptoInfo['ptopc_manager']  = this.pc.manager;
            this.ptoInfo['ptopc_pending_months']  = this.pc.pending_months;
            this.ptoInfo['ptopc_pending_mgr_approval']  = this.pc.pending_mgr_approval;

            this.ptoInfo['showBalanceBadge'] = pto_func.get_badge_status(
                "balance",
                this.pc.pending_confirmed, "");

            if (this.pc.manager == "Y") {
                this.ptoInfo['showManagerTab'] = true;
                this.ptoInfo['showDelegateForm'] = true;
            }

            if (this.pc.is_faculty == "Y") {
                this.ptoInfo['showReqBalTab'] = false; // faculty approver cannot submit request 
                this.ptoInfo['isFaculty'] = true ;
            }

            if (this.ptoInfo['showReqBalTab'] && pto_func.show_prev_balance())
                this.ptoInfo['showBalPrevTab'] = true; 

            if (this.ptoInfo['showReqBalTab'] && this.site_status == "cur_and_next_year")
                this.ptoInfo['showBalNextTab'] = true;

            if (this.pc.pending_mgr_approval == "Y")
                this.ptoInfo['showManagerBadge'] = true; 

            this.ptoInfo['p_cfm_this_month'] = pto_func.get_cfm_status(
              "this_month",
              this.pc.pending_confirmed
            );

            this.ptoInfo['p_cfm_prev'] = pto_func.get_cfm_status(
              "prev",
              this.pc.pending_confirmed
            );

            this.pto_access = this.pc.pto_access;

      }

      if (this.site_status == "cur_year_only")
        this.cur_year_str = "";

      this.afterCreated = true;

    });    

      axios.get("./remote-apis/pto_api.php?cmd=pto_delegate_access").then((response) => {
        this.dg = response.data;
        this.ptoInfo['delegate_access'] = this.dg.delegate;
        this.ptoInfo['delegate_approvals'] = this.dg.delegate_approvals;  
        this.ptoInfo['who_delegated'] = this.dg.who_delegated;  

        if (this.dg.delegate == "Y")
            this.ptoInfo['showManagerTab'] = true;
         
        if (this.dg.delegate_approvals == "Y")
            this.ptoInfo['showManagerBadge'] = true;
      
    });    

    // compressed workweek
    if (this.ptoInfo['isFaculty'] === false ) {
      axios.get("./remote-apis/pto_api.php?cmd=pto_comp_week").then((response) => {
        this.comp_wk = response.data;
        this.ptoInfo['showCompWeekInfo'] = this.comp_wk.showCompWeekInfo; 
        this.ptoInfo['showCompWeekForm'] = this.comp_wk.showCompWeekForm;  
      });    

      axios.get("./remote-apis/pto_api.php?cmd=pto_cw").then((response) => {
        this.cw = response.data;
        if (this.cw.response == 0) {
          if (this.cw.cw_opt_in == 1 || this.cw.cw_opt_in == "1" ) {
            this.ptoInfo['cw_opt_in'] = true;
            this.ptoInfo['cw_day'] = this.cw.cw_day;
            this.ptoInfo['showCompWeekBadge'] = true;  
          }
        }

    });      


    }

    this.timeoutInit();

 },

 mounted() {
  /*
    // init chatbot
    if (!window.admitHubBot || window.admitHubBot == undefined) {
        window.admitHubBot = {botToken: "1a59f302dc694a47a", collegeId: "6a25b98237804be1b"};
        var s = document.createElement("script"); 
        s.type = "text/javascript"; 
        s.async = true;
        s.src = "https://webbot.mainstay.com/static/js/webchat.js";
        var h = document.getElementsByTagName("body")[0]; 
        h.appendChild(s);     
    } else {
        // after chatbot is loaded, clicking on Personnel and Professional tabs would set chatbot display: none
        // remove the display none here
        // do not init chatbot again, will cause error
        document.querySelectorAll('._admithub_embed-container').forEach(function(el) {
          el.style.display = '';
        });
    }
    */
 },

  methods: {

    timeoutInit () {
      var self = this;
      setTimeout(function () {
        self.timeout_dialog = true;
        self.showTimeoutDialog();
        // 1.5 hour: 4900000
        // test: 40000
      }, 4900000);

    },

    // No response from timeout dialog. Redirect logout.
    showTimeoutDialog() {
     var self = this;
     self.timeout_redirect = setTimeout(function () {
        self.timeout_dialog = false;
        self.timeoutRedirect();
        // show dialog for 60 seconds: 60000
        // test: 30000
      }, 60000);
    },

    timeoutRedirect() {
      window.location.href = "./remote-apis/logout.php";
    },

    closeTimeoutDialog(type) {
      if (type == "keepAlive") {
        this.timeout_dialog = false;
        clearTimeout(this.timeout_redirect);
        this.timeoutInit();
      } else {
        this.timeoutRedirect();
      }
    },

    pauseYouTube(id) {
      var iframe = document.getElementById(id);
      if (iframe) {
         //iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');  
         iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');  
      }
    }
  
  },

}
</script>

<style scoped>


@media (min-width: 1264px) {
  .container {
      max-width: 1185px;
  }
}
</style>